import React, { useState, useEffect, useCallback } from 'react';
import { withStyles } from '@mui/styles';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { TagsDropdowns } from 'tags';
import {
  upsertOrganizationTag,
  deleteOrganizationTag,
} from 'store/actions/organizationTagsActions';
import { listTagNamespacesByClient } from 'store/actions/tagNamespacesActions';
import { loadOrganization } from 'store/actions/organizationsActions'
import { StoreUtil } from 'doctivity-shared/utils';
import { TagsUtil } from '../utils';

const styles = () => ({});

function EditOrganizationTags({ open, setOpen, organization, dispatch, tagNamespaces, clientId }) {
  const [selectedTags, setSelectedTags] = useState([]);
  const onCancel = useCallback(() => {
    setSelectedTags([]);
    setOpen(false);
  }, []);
  const onSaveMultiSelect = useCallback(() => {
    const tagIds = new Set(organization.tags.map((t) => t.id));
    const selectedTagIds = new Set(selectedTags.map((t) => t.id));
    const addedTags = selectedTags.filter((st) => !tagIds.has(st.id));
    const removedTags = organization.tags.filter((t) => !selectedTagIds.has(t.id));
    // console.error('adding', addedTags, 'removing', removedTags);
    if (addedTags.length > 0) {
      dispatch(
        upsertOrganizationTag(
          addedTags.map((t) => ({ tag_id: t.id, organization_id: organization.id })),
          loadOrganization(organization.id, clientId),
        ),
      );
    }
    if (removedTags.length > 0) {
      dispatch(
        deleteOrganizationTag(
          removedTags.map((tag) => ({
            organization_id: organization.id,
            tag_id: tag.id,
          })),
          undefined,
          loadOrganization(organization.id, clientId),
        ),
      );
    }
    setOpen(false);
  }, [dispatch, organization, selectedTags, clientId]);
  useEffect(() => {
    if (StoreUtil.needsLoadLongCache(tagNamespaces) || tagNamespaces.clientId !== clientId) {
      dispatch(listTagNamespacesByClient(clientId));
    }
  });
  useEffect(() => {
    const selTags = organization?.tags;
    if (Array.isArray(selTags) && selTags.length > 0) {
      setSelectedTags(selTags);
    }
  }, [tagNamespaces, organization, open]);
  const clearNamespace = useCallback((nsId) => {
    setSelectedTags(selectedTags.filter((t) => TagsUtil.findNamespaceForTagId(t.id, tagNamespaces)?.id !== nsId));
  }, [selectedTags]);

  return (
    <Dialog
      onClose={() => setOpen(false)}
      aria-labelledby='simple-dialog-title'
      fullWidth
      open={open}
      scroll='paper'
    >
      <DialogTitle>Edit Organization Labels</DialogTitle>
      <DialogContent dividers>
        <TagsDropdowns 
          type={'organizations'}
          embedded={true}
          selectedTags={selectedTags}
          tagNamespaces={tagNamespaces}
          clearSelectedNamespace={clearNamespace}
          selectTag={(tag) => {
            const currentTagIndex = selectedTags.findIndex((t) => t.id === tag.id);
            if (currentTagIndex > -1) {
              setSelectedTags(selectedTags.toSpliced(currentTagIndex, 1));
            } else {
              setSelectedTags([...selectedTags, tag]);
            }
          }}
        />
        <DialogActions>
          <Button onClick={onCancel} color='primary'>
            Cancel
          </Button>
          <Button
            onClick={onSaveMultiSelect}
            variant='contained'
            color='primary'
          >
            Save
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

function mapStateToProps(state) {
  return {
    tagNamespaces: StoreUtil.get(state.tagNamespaces, 'API_TAG_NAMESPACES_LIST_BY_CLIENT'),
    clientId: state.app.selectedClient,
  };
}

EditOrganizationTags.propTypes = {
  dispatch: PropTypes.func,
  classes: PropTypes.object,
  open: PropTypes.bool,
  organization: PropTypes.object,
  setOpen: PropTypes.func,
  tagNamespaces: PropTypes.object.isRequired,
  clientId: PropTypes.number,
};
const styled = withStyles(styles)(EditOrganizationTags);
const connected = connect(mapStateToProps)(styled);
export { connected as EditOrganizationTags };
